import { Component, Inject } from '@angular/core';
import { IconComponent, Icons } from '@ansys-internal/awc-angular/icons';
import { LogoComponent } from '@ansys-internal/awc-angular/images';
import { TITLE } from '@ansys-internal/awf-angular/auth';
import { ConceptService } from '../../../shared/services/concept.service';

@Component({
    selector: 'app-loading-content-screen',
    imports: [IconComponent, LogoComponent],
    templateUrl: './loading-content-screen.component.html',
    styleUrl: './loading-content-screen.component.scss'
})
export class LoadingContentScreenComponent {
  constructor(
    @Inject(TITLE) protected appName: string,
    protected conceptService: ConceptService
  ) {}

  protected readonly Icons = Icons;
}
